"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function LetterIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M19.429,5.687H4.571A2.342,2.342,0,0,0,2.232,8.025v7.95a2.342,2.342,0,0,0,2.339,2.338H19.429a2.342,2.342,0,0,0,2.339-2.338V8.025A2.342,2.342,0,0,0,19.429,5.687ZM18.2,7.387,12,11.863,5.8,7.387Zm1.232,9.226H4.571a.638.638,0,0,1-.638-.638V8.133L11.5,13.6a.851.851,0,0,0,1,0l7.569-5.467v7.842A.638.638,0,0,1,19.429,16.613Z" })));
}
exports.default = LetterIcon;
